export default __webpack_public_path__ + "static/media/azure-metrics.7268d9e0.svg";